import { render, staticRenderFns } from "./ShippingInformation.vue?vue&type=template&id=8c79794a&"
import script from "./ShippingInformation.vue?vue&type=script&lang=js&"
export * from "./ShippingInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports